import {
  Component,
  ComponentRef,
  ViewChild,
  ViewContainerRef
} from "@angular/core";
import {DynamicComponentService} from "../../services/dynamic-component/dynamic-component.service";
import {OptionService} from "../../services/option/option.service";
import {WordHelpPopupComponent} from "./word-help-popup.component";
import {GlobalEventService} from "../../services/global-event/global-event.service";


@Component({
  selector: 'app-word-help-btn',
  template: `
    <aside #container
           class="page-help-box">

      <a class="page-help-btn" (click)="onClick($event)">
        <i class="ic ic-help"></i>
        <span class="txt">도움말</span>
      </a>
    </aside>
  `,
})
export class WordHelpBtnComponent {
  @ViewChild('container', { read: ViewContainerRef }) container?: ViewContainerRef;
  private componentRef: ComponentRef<WordHelpPopupComponent> | null = null;

  constructor(
    private dynamicSvc: DynamicComponentService,
    private optionSvc: OptionService,
    private globalEventSvc: GlobalEventService,
  ) {

  }

  onClick($event: MouseEvent) {
    $event.preventDefault();
    $event.stopPropagation();
    this.globalEventSvc.Click($event, true);

    if (!this.container === null) {
      throw new Error(`WordHelpBtnComponent::ngOnInit() container is null`);
    }

    if (this.componentRef) {
      this.closePopup();
    }
    else {
      this.componentRef = this.dynamicSvc.createComponent(WordHelpPopupComponent, this.container);
      this.componentRef.instance.close.subscribe((autoPlay: boolean | null) => {
        // console.log('WordHelpBtnComponent::ngAfterViewInit() close.subscribe()', showSaseung);

        if (autoPlay !== null) {
          this.optionSvc.autoPlay = autoPlay;
        }

        this.closePopup();
      });
    }
  }

  private closePopup() {
    this.componentRef?.destroy();
    this.componentRef = null;
  }
}
